namespace advisorop.components.identity {

    class LoginFormContainerController {
        
        $router;

        uiType: string;
        okToPaint: boolean = false;

        pnlMainPanel: advisorop.components.widgets.AdvisoropPanelController;

        constructor(private identityService: services.IdentityService) {
        }

        onMainPanelReady(ctrl) {
            this.pnlMainPanel = ctrl;
        }

        $onInit(): void {
            //this.show2FAScreen = false;
        }

        $routerOnActivate(next, previous) {

            //this.show2FAScreen = false;

            //case when user enter logout path
            if (next.urlPath == "logout")
            {
                localStorage.clear();
            }

            if (next != null && next.params != null)
                this.uiType = next.params.uiType;

            // redirect screens less than 800 pixels wide to the mobile site unless desktop uiType is forced
            if (this.uiType != "desktop" && window.screen.availWidth < 800) {
                var href: string = "https://m." + location.host;
                window.location.replace(href);
            }
            else
                this.okToPaint = true;
        }
    }



    class LoginFormContainer implements ng.IComponentOptions {
        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        public host: any;

        constructor() {
            this.bindings = {
                $router: '<'
            };
            this.controller = ["identityService", LoginFormContainerController];
            this.controllerAs = "vm";
            this.templateUrl = 'spa/shared/identity-module/components/login-form-container.html';
        }

    }
    angular.module(Constants.APP).component("loginFormContainer", new LoginFormContainer());
}